/**
 * @description Combines default and new fetch params.
 */
const combineFetchParams = (defaultParams: object, params?: any): any => {
  let updatedParams = {
    ...defaultParams,
  };
  if (params) {
    updatedParams = Object.keys(params).reduce(
      (accum, key: string) => {
        const param = {
          ...accum,
        } as any;
        // avoid adding empty arrays to fetch params
        if (Array.isArray(params[key]) && !params[key].length) {
          return param;
        }
        param[key] = params[key];
        return param;
      },
      {
        ...updatedParams,
      }
    );
  }
  return updatedParams;
};

export default combineFetchParams;
